module.exports = __webpack_public_path__ + "img/Neuron_Logo_White.5ea30604.png";